import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  footer: {
    position: 'absolute',
    bottom: '0px',
    left: '0px',
    right: '0px',
    height: '3.5cm',
    backgroundColor: '#f8f9fa',
    borderTop: '2px solid #548235',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: '0.6cm',
    paddingHorizontal: '1.5cm',
    boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
  },
  footerContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  companyName: {
    fontFamily: 'Helvetica-Bold',
    fontSize: '11px',
    color: '#2c3e50',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: '0.2cm',
  },
  companyDescription: {
    fontFamily: 'Helvetica',
    fontSize: '9px',
    color: '#7f8c8d',
    fontStyle: 'italic',
    marginBottom: '0.2cm',
  },
  website: {
    fontFamily: 'Helvetica',
    fontSize: '10px',
    color: '#548235',
    textDecoration: 'none',
  },
});

function BudgetFooter({ config }) {
  return (
    <View style={styles.footer} fixed>
      <View style={styles.footerContent}>
        <Text style={styles.companyName}>
          {config?.footer ??
            'LiftLogic - Por Sociedad de Tecnología e Innovación Limitada'}
        </Text>
        <Text style={styles.companyDescription}>
          Soluciones profesionales en elevación y mantenimiento
        </Text>
        <Text style={styles.website}>
          {config?.footer_secondary ?? 'www.liftlogic.cl'}
        </Text>
      </View>
    </View>
  );
}

export default BudgetFooter;
